import { Box, OutcomeLoader, PrimaryButton, Typography } from "@husqvarna/ui-core";
import { ReactComponent as HusqvarnaLogo } from "../shared/icons/husqvarna-logo.svg";
import { useIntl } from "react-intl";
import { useLocation } from "react-router";
import "./Login.scss";

export interface LoginProps {
  isLoading: boolean;
}

const Login = ({ isLoading }: LoginProps) => {
  const intl = useIntl();
  const location = useLocation();

  const handleLogin = () => {
    window.location.href = '/api/authentication/login';
  };

  const urlParams = new URLSearchParams(location.search);
  const messageParam = urlParams.get('message');
  const showMissingPermissionError = messageParam === 'missing_isam_tcsp_group';
  return (
      <Box className="login-wrap">
        <Box px={15} height={"full"} flexDirection="column" justifyContent="space-between" className="login-content">
          <Box>
            <HusqvarnaLogo height={60} width={60} className="logo" />
            <Typography variant="Heading3" mb={4} mt={[10, 15, 25]} tag="h1" text={intl.formatMessage({id: "login.header", defaultMessage: "Welcome to Turf Care Site Planner"})} />
            {isLoading && (
              <Box mt={10} container justifyContent="center" alignItems="center">
                <OutcomeLoader size={20} />
              </Box>
            )}
            {!isLoading && (
              <Box>
                <Typography variant="Body1" tag="p" text={intl.formatMessage({id: "login.description", defaultMessage: "You are being redirected to Husqvarna's login for authentication."})} />
                <PrimaryButton mt={10} width={"full"} onClick={handleLogin} text={intl.formatMessage({id: "login.primaryButton", defaultMessage: "Log in"})} />
                {showMissingPermissionError && (
                  <Box >
                    <Typography variant="Body2" mt={10} color="ErrorRed" text={intl.formatMessage({id: "login.missingPermissions", defaultMessage: "Your account does not have the required permissions to access this application. Please request access through the IT Service Portal or contact your local PRO sales manager for assistance."})} />
                  </Box>
                )}
              </Box>
            )}
          </Box>
          <Box>
            <Typography variant="Microcopy" py={4} text={intl.formatMessage({id: "login.copyright", defaultMessage: "Copyright ©️ Husqvarna AB (publ). All rights reserved."})}/>
          </Box>
        </Box>
        <div 
          style={{backgroundImage: 'url(/login-bg.jpg)'}} 
          className="login-bg" 
        />
      </Box>
  );
}

export default Login;